@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

.job-work-summary {

	&__empty-cell {
		color: Colors.$col-greyFontLight;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}
	}

	&__review-status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-greyFontLight;
			}
		}

		&--in-progress {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--outdated {
			[class^="icon-dot_outline"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--reviewed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
			}
		}

		&--completed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-green;
				font-weight: bold;
			}
		}

		&--sub-row-cell {
			color: Colors.$col-greyFontLight;
		}

		&>b {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
}